import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import { parse, format } from 'date-fns';

@Injectable()
export class PGHCreditCardDateAdapter extends NativeDateAdapter {
  parse(value: any): Date | null {
    if (value != null && value.length < 5) return null;
    const dateValue = parse(value, 'MM/yy', new Date());
    if (dateValue != null) return dateValue;
    return null;
  }

  format(date: Date): string {
    return format(date, 'MM/yyyy');
  }
}
